import { useLangStore } from "@/CommonVueCore/src/store/stores/langStores";
import localization from "@/localization/localization";

function ChangeLang(_lang) {
  const langStore = useLangStore();
  langStore.setLangInfo(_lang);
}

function CheckLang() {
  var langStore = useLangStore();
  var selectedLang = langStore.$state.lang; //langStore.getLangInfo

  // console.log("langg1",selectedLang)
  
  if (!selectedLang) {
    //bazen burdan "en-US" gelebiliyor.
    let locale = localization.global.locale;
// console.log("langg2",locale)
    // Normalize et -> "en-US" → "en", "tr-TR" → "tr"
    locale = (locale || "EN").split("-")[0].toUpperCase();

    // console.log("langg3",locale)

    langStore.setLangInfo(locale);
    localization.global.locale = locale; // i18n locale’ini de normalize et
  }
  else {
    localization.global.locale = selectedLang.toUpperCase();
  }
}

function GetSelectedLang() {
  var langStore = useLangStore();
  var selectedLang = langStore.$state.lang;
  return selectedLang;
}

function ResetLang() {
  const langStore = useLangStore();
  langStore.setResetLang();
}

export default {
  ChangeLang,
  CheckLang,
  GetSelectedLang,
  ResetLang,
};
